/* eslint-disable camelcase */
export enum ChatbotAssistantTypes {
  FETCH_ASSISTANT_USER_CHAT_MESSAGES_REQUEST = '@chatbot_assistant/FETCH_ASSISTANT_USER_CHAT_MESSAGES_REQUEST',
  FETCH_ASSISTANT_USER_CHAT_MESSAGES_SUCCESS = '@chatbot_assistant/FETCH_ASSISTANT_USER_CHAT_MESSAGES_SUCCESS',
  FETCH_ASSISTANT_USER_CHAT_MESSAGES_FAILURE = '@chatbot_assistant/FETCH_ASSISTANT_USER_CHAT_MESSAGES_FAILURE',
  CREATE_ASSISTANT_USER_CHAT_REQUEST = '@chatbot_assistant/CREATE_ASSISTANT_USER_CHAT_REQUEST',
  CREATE_ASSISTANT_USER_CHAT_SUCCESS = '@chatbot_assistant/CREATE_ASSISTANT_USER_CHAT_SUCCESS',
  CREATE_ASSISTANT_USER_CHAT_FAILURE = '@chatbot_assistant/CREATE_ASSISTANT_USER_CHAT_FAILURE',
  CREATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST = '@chatbot_assistant/CREATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST',
  CREATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS = '@chatbot_assistant/CREATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS',
  CREATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE = '@chatbot_assistant/CREATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE',
  UPDATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST = '@chatbot_assistant/UPDATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST',
  UPDATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS = '@chatbot_assistant/UPDATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS',
  UPDATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE = '@chatbot_assistant/UPDATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE',
  FETCH_ASSISTANT_USER_CHATS_REQUEST = '@chatbot_assistant/FETCH_ASSISTANT_USER_CHATS_REQUEST',
  FETCH_ASSISTANT_USER_CHATS_SUCCESS = '@chatbot_assistant/FETCH_ASSISTANT_USER_CHATS_SUCCESS',
  FETCH_ASSISTANT_USER_CHATS_FAILURE = '@chatbot_assistant/FETCH_ASSISTANT_USER_CHATS_FAILURE',
  UPDATE_SELECTED_CHAT_ID = '@chatbot_assistant/UPDATE_SELECTED_CHAT_ID',
}

export interface UserChatMessageTypes {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  rating: boolean | null;
  assistant_user_chat_id: number;
  created_at: string;
  updated_at: string;
}

export interface CurrentUserChatMessageTypes {
  id: number | null;
  role: 'user' | 'assistant';
  content: string;
  created_at: string;
  updated_at: string;
  rating: boolean | null;
}

export interface UserChatTypes {
  id: number;
  usuario_id: number;
  last_message_time: string;
  conversation_id: string;
  created_at: string;
  updated_at: string;
}

export interface ChatbotAssistantDataTypes {
  current_chat_id: number | null;
  user_chats: Array<UserChatTypes>;
  current_chat_messages: Array<CurrentUserChatMessageTypes>;
  user_chat_messages: {
    [key: string]: Array<UserChatMessageTypes>;
  };
}

interface DefaultRequestTypes {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  fetch_user_chat_message: DefaultRequestTypes;
  create_user_chat_message: DefaultRequestTypes;
  update_user_chat_message: DefaultRequestTypes;
  fetch_user_chats: DefaultRequestTypes;
  create_user_chat: DefaultRequestTypes;
}

export interface ChatbotAssistantState {
  readonly chatbot_assistant: ChatbotAssistantDataTypes;
  readonly request: RequestState;
}
